import React from 'react';

import classes from './Toolbar.css';
import Logo from '../../Logo/Logo';
import NavigationItems from '../NavigationItems/NavigationItems';
import DrawerToggle from '../SideDrawer/DrawerToggle/DrawerToggle';


const toolbar = ( props ) => (
    <header className={classes.Toolbar}>
        <DrawerToggle clicked={props.drawerToggleClicked} />
        <a className={classes.Brand} href={process.env.PUBLIC_URL + '/'}>
            <div className={classes.Logo}>
                <Logo />
            </div>
            <span>Burger Builder</span>
        </a>
        <nav className={classes.DesktopOnly}>
            <NavigationItems />
        </nav>
    </header>
);

export default toolbar;



// WEBPACK FOOTER //
// ./src/components/Navigation/Toolbar/Toolbar.js